module.exports = __webpack_public_path__ + "static/media/Awei-Pila.9a98f76e.png";